import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useGetQuestionByIdMutation } from '../../../../features/authentication/assignApiSlice';
import QuestionDetail from '../../components/QuestionDetail';
import QuestionPreviewTypes from '../../../../enums/questionPreviewTypes';
import {
  useGetUngradedSessionsMutation, useGetCRQuestionsMutation,
  useGetChartDataMutation,
  useRevokeGradeMutation
} from '../../../../features/authentication/assessmentApiSlice';
import { PieChart } from 'react-minimal-pie-chart';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/pro-solid-svg-icons';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';
import CustomToast from '../../../../components/Toast';
import RecentScoreModal from './RecentScoreModal';
import { useUpdateCrAnswerMutation } from '../../../../features/authentication/assignmentApislice';

const AssessmentGrading = () => {
  const [assessmentName, setAssessmentName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [questionDetails, setQuestionDetails] = useState({});
  const [actualQuestionIndex, setActualQuestionIndex] = useState(-1);
  const [ungradedSessions, setUngradedSessions] = useState([]);
  const [currentSession, setCurrentSession] = useState(null);
  const [gradeQuestions, setGradeQuestions] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [openRecentScoreModal, setOpenRecentScoreModal] = useState(false);
  const [score, setScore] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isGradeSave, setIsGradeSave] = useState(false);

  const [getCRQuestions] = useGetCRQuestionsMutation();
  const [getQuestionDetailsById] = useGetQuestionByIdMutation();
  const [getUngradedSessions] = useGetUngradedSessionsMutation();
  const [getChartData] = useGetChartDataMutation();
  const [saveCRGrade] = useUpdateCrAnswerMutation();
  const [revokeGrade] = useRevokeGradeMutation();

  const { Id } = useParams();
  const previewOptions = {
    hideOptions: true,
    hideResources: true,
    hideProperties: true,
    hidePrevNextButton: true,
    skeletonCount: 2
  };

  useEffect(() => {
    getCRQuestionsAsync();
  }, []);

  useEffect(() => {
    if (actualQuestionIndex >= 0) {
      getUngradedSessionsAsync();
      getChartDataAsync();
      setCurrentSession(null);
    }
  }, [actualQuestionIndex]);

  const getCRQuestionsAsync = async () => {
    const option = {
      assessmentId: Id
    };
    var response = await getCRQuestions(option).unwrap();
    setAssessmentName(response.assessmentName);
    setGradeQuestions(response.questions);
    setActualQuestionIndex(response.questions[0].questionIndex);
    getQuestionDetailsByIdHandler(response.questions[0].questionId, response.questions[0].questionIndex);
  };

  const getUngradedSessionsAsync = async () => {
    setIsLoading(true);
    setScore(0);
    var selectedQuestion = gradeQuestions.find(item => item.questionIndex == actualQuestionIndex);
    const option = {
      courseId: selectedQuestion.courseId,
      questionId: selectedQuestion.questionId,
      assessmentId: Id
    };
    var response = await getUngradedSessions(option).unwrap();
    if (response.length > 0) {
      setUngradedSessions(response);
      const session = getRandomRecord(response);
      setCurrentSession(session);
    }
    setIsLoading(false);
  };

  const getChartDataAsync = async () => {
    setIsLoading(true);
    var selectedQuestion = gradeQuestions.find(item => item.questionIndex == actualQuestionIndex);
    const option = {
      courseId: selectedQuestion.courseId,
      questionId: selectedQuestion.questionId,
      assessmentId: Id
    };
    var response = await getChartData(option).unwrap();
    setChartData(response);
    setIsLoading(false);
  };

  const getQuestionDetailsByIdHandler = async (questionId, index) => {
    setIsLoading(true);
    setActualQuestionIndex(index);
    let option = { assignmentId: Id, questionId: questionId, languageId: 0 };
    try {
      const response = await getQuestionDetailsById(option).unwrap();
      setQuestionDetails(response);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  };

  const getRandomRecord = (arr) => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  };

  const saveCRGradeAsync = async () => {
    if(!isGradeSave){
      setIsGradeSave(true);
      var selectedQuestion = gradeQuestions.find(item => item.questionIndex == actualQuestionIndex);
      const option = {
        sessionId: currentSession.sessionId,
        studentId: currentSession.studentId,
        questionId: selectedQuestion.questionId,
        score: score,
        courseId: selectedQuestion.courseId,
        assignmentId: parseInt(Id)
      };
      await saveCRGrade(option).unwrap();
      if(isEditMode){
        CustomToast('Grade updated successfully', 'success');
        setIsEditMode(false);
      }
      else
        CustomToast('Question graded successfully', 'success');
      setScore(0);
      const newSessions = ungradedSessions.filter(item => item.sessionId != currentSession.sessionId);
      setUngradedSessions(newSessions);
      if (newSessions.length > 0) {
        const newSession = getRandomRecord(newSessions);
        setCurrentSession(newSession);
      }
      else
        setCurrentSession(null);
      getChartDataAsync();
      setIsGradeSave(false);
    }
  };

  const handleRevokeGrade = async (sessionId) => {
    var selectedQuestion = gradeQuestions.find(item => item.questionIndex == actualQuestionIndex);
    const option ={
      questionId:selectedQuestion.questionId,
      courseId:selectedQuestion.courseId,
      sessionId:sessionId
    };
    await revokeGrade(option).unwrap();
    CustomToast('Session Unscored successfully','success');
    getUngradedSessionsAsync();
    getChartDataAsync();
  };

  const handleSkip = ()=>{
    const updatedSessions = ungradedSessions.filter(item => item.sessionId != currentSession.sessionId);
    const newSession = getRandomRecord(updatedSessions);
    setCurrentSession(newSession);
  };

  const handleCancel = ()=>{
    const newSession = getRandomRecord(ungradedSessions);
    setScore(0);
    setCurrentSession(newSession);
    setIsEditMode(false);
  };

  return (
    <>
      <div className='white-card'>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='d-flex align-items-center gap-3'>
            <h5>Assessment Grading For </h5><label className='fs-5 pb-2'>{assessmentName}</label>
          </div>
          <div>
            <button className='btn btn-castleWhite btn-width' onClick={() => window.history.back()}>Back</button>
          </div>
        </div>
        <div className="d-flex flex-row my-3 questionDetails">
          <div className="crQuestionsGrid">
            {gradeQuestions?.map((item, index) => {
              return (
                <button
                  key={`questionButton-${index}`}
                  className={`questionNumberButton ${item.questionIndex == actualQuestionIndex ? 'active' : ''}`}
                  onClick={() => {
                    setActualQuestionIndex(item.questionIndex);
                    setQuestionDetails({});
                    getQuestionDetailsByIdHandler(item.questionId, item.questionIndex);
                  }}>
                  {item.questionIndex + 1}
                </button>
              );
            })}
          </div>
          <div className="d-flex flex-column w-75">
            <QuestionDetail
              questionDetails={questionDetails}
              setQuestionDetails={setQuestionDetails}
              selectedQuestionId={actualQuestionIndex}
              isLoading={isLoading}
              assignmentId={Id}
              type={QuestionPreviewTypes.assignmentPreview}
              previewOptions={previewOptions}
            />
          </div>
        </div>
        {isLoading ? (
          <Row>
            <Col>
              <SkeletonGrid
                rowCount={2}
                colCount={1}
                className='p-2 mt-4' />
            </Col>
            <Col>
              <Row>
                <Col>
                  <SkeletonGrid
                    rowCount={3}
                    colCount={1}
                    className='p-1 mt-3' />
                </Col>
                <Col>
                  <SkeletonGrid
                    rowCount={3}
                    colCount={1}
                    className='p-1 mt-3' />
                </Col>
              </Row>
              <SkeletonGrid
                rowCount={2}
                colCount={1}
                className='p-3 mt-4' />
            </Col>

          </Row>
        ) : (
          <Row className='mt-4 p-3'>
            <Col className='col-6'>
              <h5>Student Answer</h5>
              {currentSession ? (
                <div className='mt-4' dangerouslySetInnerHTML={{ __html: currentSession.answer}}></div>) : (
                <div className='mt-4'>There are no answers to grade this question.<br />Try changing questions.</div>
              )}
            </Col>
            <Col className='col-6 reportBox p-5'>
              <div className='d-flex justify-content-between'>
                <div>
                  <p>Assessment Owner : <label className='fw-semibold'>{chartData?.assessmentOwner}</label></p>
                  <p>Total Assigned : <label className='fw-semibold'>{chartData?.totalAssigned}</label></p>
                  {currentSession && <p>Session ID : <label className='fw-semibold'>{currentSession.sessionId}</label></p>}
                </div>
                <div className='d-flex gap-3'>
                  <div>
                    <PieChart
                      data={[
                        { title:`${chartData?.ungraded} Ungraded`, value: chartData?.ungraded, color: '#FB7F7F' },
                        { title:`${chartData?.graded} Graded`, value: chartData?.graded, color: '#52C9A5' },
                        { title:`${chartData?.unanswered} Unanswered`, value: chartData?.unanswered, color: '#FFC27A' },
                      ]}
                      lineWidth={35}
                      startAngle={270}
                      style={{ height: '110px' }}
                    />
                  </div>
                  <div>
                    <p><label className='fw-semibold'>{chartData?.ungraded}</label> Ungraded</p>
                    <p><label className='fw-semibold'>{chartData?.graded}</label> Graded</p>
                    <p><label className='fw-semibold'>{chartData?.unanswered}</label> Unanswered</p>
                  </div>
                </div>
              </div>
              <div className='line'></div>
              <div className='d-flex justify-content-between mt-4 align-items-center'>
                <div className='fw-semibold'>Score</div>
                <div className='d-flex align-items-center gap-3'>
                  <label>{`(min: 0   max: ${questionDetails.question?.options?.maxPoint})`}</label>
                  <div className="flex bg-lightgray p-2 rounded">
                    <button
                      onClick={() => setScore(score - 1)}
                      className={`btn px-3 py-1 bg-white border-0 rounded cursor-pointer ${score == 0 && 'disabled'}`}
                    ><label className='fs-4 cursor-pointer'>-</label></button>
                    <span className="text-xl font-bold mx-4">{score}</span>
                    <button
                      onClick={() => setScore(score + 1)}
                      className={`btn px-3 py-1 bg-white border-0 rounded cursor-pointer ${(score == questionDetails.question?.options?.maxPoint) && 'disabled'}`}
                    ><label className='fs-4 cursor-pointer'>+</label></button>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center mt-4'>
                {!isEditMode &&
                <div className='text-orange cursor-pointer' onClick={() => setOpenRecentScoreModal(true)}><FontAwesomeIcon icon={faAward} className='mr-2' />Recent Score</div>
                }
                <div>
                  <button className='btn btn-castleWhite btn-width mx-2' onClick={() => {isEditMode ? handleCancel(): handleSkip();}} disabled={!isEditMode && (ungradedSessions.length == 1 || ungradedSessions.length == 0)}>{isEditMode ?'Cancel': 'Skip'}</button>
                  <button className='btn btn-castleRed btn-width' onClick={() => saveCRGradeAsync()} disabled={ungradedSessions.length == 0}>{isEditMode ?'Update': 'Submit'}</button>
                </div>               
              </div>
            </Col>
          </Row>
        )}
        {openRecentScoreModal &&
          <RecentScoreModal
            isOpen={openRecentScoreModal}
            onClose={setOpenRecentScoreModal}
            questionId={gradeQuestions.find((item) => item.questionIndex == actualQuestionIndex)?.questionId}
            courseId={gradeQuestions.find((item) => item.questionIndex == actualQuestionIndex)?.courseId}
            assessmentId={Id}
            grader={chartData?.assessmentOwner}
            setIsEditMode={setIsEditMode}
            setCurrentSession={setCurrentSession}
            revokeGrade={handleRevokeGrade}
            setScore={setScore}
          />
        }
      </div>
    </>
  );
};

export default AssessmentGrading;
